import PricingV2 from './PricingV2';
export default PricingV2;